/* unplugin-vue-components disabled */import script from "./CommonSearchNew.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonSearchNew.vue?vue&type=script&lang=ts&setup=true"

import "./CommonSearchNew.vue?vue&type=style&index=0&id=6ef69982&scoped=true&lang=less"

import exportComponent from "D:\\workspace\\home-power-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ef69982"]])

export default __exports__